import http from '../config'
const coupon = {
  list(params) {
    return http({
      url: 'coupon/list',
      params
    })
  },
  get(id) {
    return http({
      url: 'coupon/get/' + id, method: 'post'
    })
  },
  listV2(params) {
    return http({
      url: 'coupon/user_coupon_all_list',
      params
    })
  },
  getCouponDetail(params) {
    return http({
      url: 'coupon/detail',
      params
    })
  },
  giveCoupon(params) {
    return http({
      url: 'coupon/donation',
      params
    })
  },
  getGivenCouponStatus(params) {
    return http({
      url: 'coupon/donation_detail',
      params
    })
  },
  receiveCoupon(params) {
    return http({
      url: 'coupon/receive',
      params
    })
  }
}
export default coupon
